export default function Logout() {
  localStorage.removeItem("token");
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/login";
}
